/**
 * Generated by orval. Do not edit manually.
 */

export type BrevoProposalKindType =
  (typeof BrevoProposalKindType)[keyof typeof BrevoProposalKindType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrevoProposalKindType = {
  WIRE: 'WIRE',
  RETUNE: 'RETUNE',
  COHORT: 'COHORT',
  NEW_TRIGGER: 'NEW_TRIGGER',
  HYGIENE: 'HYGIENE',
} as const
